module.exports = __webpack_public_path__ + "img/formulaEle.3dc0daea.svg";